import { PaginationItems } from './interfaces'
// data- / params-  props

export interface DefaultInboxParamsProps {
	id: string
}

export interface GetInboxParamsProps {
	offset?: number
	limit?: number
	startDate?: string
	endDate?: string
	isRead?: boolean
	isPinned?: boolean
	fromId?: string[]
	query?: string
	category?: InboxNotificationCategory
	columnFilters?: any[]
}

export interface UpdateStatusInboxDataProps {
	value: boolean
	id: string
}

export interface MultiActionInboxDataProps {
	data: {
		value: boolean
		notifications: string[]
	}
}

export interface MultiDeleteInboxDataProps {
	data: {
		notifications: string[]
	}
}

export interface DeleteInboxParamsProps {
	ids: string[]
}

//

// InboxNotificationCategory
export enum InboxNotificationCategory {
	File = 0,
	Event = 1,
	Task = 2,
	Access = 3,
	Team = 4,
	Security = 5,
}

// InboxNotificationObjectType
export enum InboxNotificationObjectType {
	User = 0,
	Group = 1,
	Role = 2,
	File = 3,
	Folder = 4,
	TodoCard = 5,
}

export type InboxItemStatus = 'read' | 'unread'

export type InboxItemUser = {
	avatar: string | null
	email: string
	id: string
	name: string
}

export type InboxNotificationObject = {
	id: string
	name: string
	type: InboxNotificationObjectType
	boardId?: string // For InboxNotificationObjectType.TodoCard type
}

export interface InboxItem {
	id: string
	category: InboxNotificationCategory
	isRead: boolean
	isPinned: boolean
	from: InboxItemUser | null // null means System Notification
	template: string
	createdAt: string | Date
	objects: InboxNotificationObject[]
}

// data

export interface GetInboxDataResponse {
	success: boolean
	data: {
		pagination: PaginationItems
		entries: InboxItem[]
	}
}

export interface GetUnreadInboxCountDataResponse {
	success: boolean
	data: number
}
